/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Box, Button, Container, Grid, TextField, Typography } from '@mui/material';
import styled from 'styled-components';
import { Controller, useForm } from 'react-hook-form';
import InputMask from 'react-input-mask';
import Swal from 'sweetalert2';
import ApiService from '../../helpers/ApiService';
import { CTA } from '../Common/CTA';
import { useDrawer } from '../../providers/DrawerProvider';

const FormRecoverPasswordContainer = styled.div`
  form {
    .MuiInputBase-root {
      color: var(--bluegray-600);
      background-color: var(--white);

      & input:disabled {
        background-color: var(--bluegray-50);
      }
    }
    .MuiFormHelperText-root {
      color: var(--error);
    }
    .MuiFormControlLabel-label  {
      color: var(--white);
    }

    hr {
      border: none;
      border-top: 1px solid rgba(0, 0, 0, 0.2);
      margin: 1rem 5rem;
    }
  }
`;

export const FormRecoverPass = () => {
  const { emailToRecoverPass, setEmailToRecoverPass, setFormPanel } = useDrawer();
  const { register, handleSubmit, formState: {errors}, control, setError, clearErrors, setValue, getValues } = useForm();
  const [ isLoading, setIsLoading ] = useState(true);
  const [ emailFieldDisabled, setEmailFieldDisabled ] = useState(false);

  useEffect(() => {
    let mounted = true;
    if(mounted) {
      register('email');
      register('code');
      register('newPassword');
      register('confirmPass');

      setValue('email', emailToRecoverPass);
      setEmailFieldDisabled(!!emailToRecoverPass || false);
    }
  
    return () => mounted = false;
  }, []);

  const openLoginDrawer = () => {
      setFormPanel("login");
      setEmailToRecoverPass('');
  }
  
  const onSave = async data => {
    if (data.newPassword !== data.confirmPass) {
      setError("confirmPass");
      return;
    }
    setIsLoading(true);
    delete data.confirmPass;

    ApiService.post('user/recovery-pass-code', data).then(( result ) => {
      if ( result.status === 200 ) {
        Swal.fire({
          title: `Senha redefinida!`,
          text: `Sua senha foi redefinida com sucesso. Agora entre utilizando sua nova senha.`,
          icon: 'success',
          confirmButtonText: 'Entrar'
        }).then(() => {
          setIsLoading(false);
          openLoginDrawer();
        });
      }
    })
    .catch( (error) => {
      let dataError = {
        icon: 'error',
        title: 'Oops...',
        text: 'Ocorreu um erro desconhecido. Tente novamente mais tarde.',
        button: 'Entendi'
      };

      if ( error && error.status === 400 ) {
        dataError.title = (typeof error.data === 'string') ? error.data : "Código incorreto";
        dataError.text = 'O código é inválido ou está expirado. Verifique seu e-mail e tente novamente.';
        dataError.button = 'Vou verificar';
        setError("code");
      }

      Swal.fire({
        icon: dataError.icon,
        title: dataError.title,
        text: dataError.text,
        confirmButtonText: dataError.button
      });

      setIsLoading(false);
    });
  }
  
  const checkConfirmPassword = (e) => {
    if (e.target.value !== getValues("newPassword") ) {
      setError("confirmPass");
      !isLoading && setIsLoading(true);
    }
    else {
      setIsLoading(false);
      clearErrors("confirmPass");
    }
  }

  return (
    <FormRecoverPasswordContainer>
      <Container>
        <form onSubmit={handleSubmit(onSave)}>
        <Grid container spacing={1}>
            <Grid item sm={12} xs={12} align="center">
              <Box mt={4} mb={2}>
                <Typography variant="body1" className="middle--text">
                  Informe o código recebido por e-mail e suas novas credenciais
                </Typography>
              </Box>
            </Grid>
            <Grid item sm={12} xs={12}>
              <Controller
                name="email"
                control={control}
                defaultValue=""
                render={ ({ field: { onChange, value }, fieldState: { error } }) => (
                  <TextField
                    id='emailRegister'
                    type="email"
                    label="Seu e-mail"
                    placeholder="Insira o e-mail que recebeu o código"
                    variant="outlined"
                    fullWidth
                    value={value}
                    onChange={(e) => onChange(String(e.target.value).toLowerCase())}
                    error={!!error}
                    helperText={errors.email && "E-mail obrigatório"}
                    disabled={emailFieldDisabled}
                  />
                )}
                rules={{ required: 'E-mail obrigatório', pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ }}
                register
              />
            </Grid>
            <Grid item sm={12} xs={12}>
              <Controller
                name="code"
                control={control}
                defaultValue=""
                render={ ({ field: { onChange, value }, fieldState: { error } }) => (
                  <InputMask
                    mask="999999"
                    maskChar=" "
                    onChange={onChange}
                    value={value}
                  >
                    { () => (
                      <div>
                        <TextField
                          id='codeField'
                          type="text"
                          pattern="\d*"
                          label="Código recebido por e-mail"
                          placeholder="Código recebido por e-mail"
                          variant="outlined"
                          fullWidth
                          value={value}
                          onChange={onChange}
                          error={!!error}
                          helperText={errors.code && "Código inválido"}
                        />
                      </div>
                    )}
                  </InputMask>
                )}
                rules={{ required: 'Código obrigatório' }}
                register
              />
            </Grid>
            <Grid item sm={12} xs={12}>
              <Controller
                name='newPassword'
                control={control}
                defaultValue=""
                render={ ({ field: {onChange, value}, fieldState: { error }}) => (
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="Nova senha"
                    placeholder="Nova senha"
                    type="password"
                    onChange={onChange}
                    value={value}
                    error={!!error}
                    helperText={errors.newPassword && "Senha deve conter pelo menos 6 caracteres"}
                  />
                )}
                rules={{ required: 'A senha deve ter no mínimo 6 caracteres', minLength: 6 }}
              />
            </Grid>
            <Grid item sm={12} xs={12}>
              <Controller
                name='confirmPass'
                control={control}
                defaultValue=""
                render={ ({ field: {onChange, value}, fieldState: { error }}) => (
                  <TextField
                    id='confirmPass'
                    variant="outlined"
                    fullWidth
                    label="Confirmar nova senha"
                    placeholder="Confirmar nova senha"
                    type="password"
                    value={value}
                    onChange={(e) => {
                      onChange(e);
                      checkConfirmPassword(e);
                    }}
                    error={!!error}
                    helperText={errors.confirmPass && "Esta senha deve ser igual a senha acima"}
                  />
                )}
                rules={{ required: 'A senha deve ter no mínimo 6 caracteres', minLength: 6 }}
              />
            </Grid>
            <Grid item sm={12} xs={12} align="center" mt={2}>
              <CTA type="submit" disabled={isLoading}>
                Redefinir senha
              </CTA>
            </Grid>
            <Grid item sm={12} xs={12} align='center'>
              <Button
                variant="text"
                className="middle--text small-text initial"
                size='small'
                onClick={() => setFormPanel('forgotPassword')}
              >
                Voltar
              </Button>
            </Grid>
          </Grid>
        </form>
      </Container>
    </FormRecoverPasswordContainer>
  )
}

export default FormRecoverPass;